import {createStyledAnimation} from '../create-styled-animation';
import {PropertyFlowDescription} from '../style-animation';
import {Duration, getDuration} from '../types';

export function fadeFlowBuilder(duration: Duration): PropertyFlowDescription[] {
	return [
		{
			name: 'opacity',
			duration: getDuration(duration),
			initial: '0',
			from: '0',
			to: '1',
			timingFunction: 'ease-in-out',
		},
		{
			name: 'visibility',
			duration: 0,
			initial: 'hidden',
			from: 'visible',
			to: 'visible',
			timingFunction: 'ease-in-out',
		},
	];
}

export const Fade = createStyledAnimation('Fade', fadeFlowBuilder);
